import { retry } from '../../utils/retry';
import { isWebView } from '../../utils/aem-utils';

const track = (param1, param2) => {
  const params = [param1];
  if (param2) {
    params.push(param2);
  }
  retry({
    maxAttempts: 5,
    checkEvery: 3000,
    checkFunction: () => Boolean(window.__satelliteLoaded),
  })
    .then(() => {
      window._satellite.track(...params);
    })
    .catch(() =>
      console.error('[ Tracking ] Satellite is not available, unable to track - param1 & param2', param1, param2)
    );
};

export const satelliteTracker = {
  getSatellite: () => {
    if (window._satellite) {
      return window._satellite;
    }
  },
  // Only track in canonical web-pages
  trackInWeb: (param1, param2) => {
    console.log('[Tracking in Web]', param1, param2);
    if (!isWebView()) {
      track(param1, param2);
    }
  },
  // Only track in web views
  trackInWebView: (param1, param2) => {
    if (isWebView()) {
      track(param1, param2);
    }
  },
};
